import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import useHomeContext from 'Context/HomeContext';
import ViewScenarioButton from './ViewScenarioButton';

const ViewScenarioButtonPicker = () => {
  const { homeResource } = useHomeContext();
  return pickFunction(homeResource, {
    [fr.relationships.facetPlanClientView.name]: () => {
      return <ViewScenarioButton resource={homeResource} />;
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default ViewScenarioButtonPicker;
